import {
    EditingKnowledgePayload,
    ActionType,
    EditingKnowledgeSimilarPayload,
} from './types'
import { MpAnswerModel } from '../../../model/knowledge.model'
let emptyFlagId = 0
export const makeEmptySimilar = (): EditingKnowledgeSimilarPayload => {
    emptyFlagId++
    return {
        k_id: 0,
        k_question: '',
        kq_id: 0,
        update: true,
        flag_id: emptyFlagId,
    }
}
const editingKnowledgeReducer = (
    state: EditingKnowledgePayload,
    action: ActionType
) => {
    switch (action.type) {
        case 'setEditingKnowledge':
            if (action.payload.KQuestions.length === 0) {
                action.payload.KQuestions = [
                    {
                        ...makeEmptySimilar(),
                    },
                ]
            }
            return { ...action.payload }
        case 'updateKnowledge':
            return {
                ...state,
                k_title: action.payload,
                k_empty: !action.payload.trim(),
                k_update: true,
            }
        case 'updateKnowledgeStatus':
            return {
                ...state,
                status: state.status === 1 ? 0 : 1,
                k_update: true,
            }
        case 'addKAnswer':
            let has_empty: boolean | undefined = true
            if (
                action.payload.k_answer_type === 1 ||
                action.payload.k_answer_type === 4 ||
                action.payload.k_answer_type === 6
            ) {
                has_empty =
                    state.KAnswers.length > 0 ? state.KAnswers_has_empty : false
            } else {
                has_empty = true
            }
            console.log(action)
            console.log(state.KAnswers)
            return {
                ...state,
                KAnswers_has_empty: has_empty,
                KAnswers: [...state.KAnswers, action.payload],
            }
        case 'updateKAnswer': {
            state.KAnswers[action.payload.index].k_answer = action.payload.value
            state.KAnswers[action.payload.index].finished =
                action.payload.finished
            state.KAnswers[action.payload.index]['update'] = true
            const initMp: MpAnswerModel = {
                Mp_App_Id: '',
                username: '',
                title: '',
            }
            let has_empty =
                state.KAnswers.filter(
                    (item) =>
                        !item.k_answer ||
                        !item.k_answer.trim() ||
                        item.k_answer === '{}' ||
                        item.k_answer === JSON.stringify(initMp)
                ).length > 0
            return {
                ...state,
                KAnswers_has_empty: has_empty,
                KAnswers: [...state.KAnswers],
            }
        }

        case 'deleteKAnswer': {
            const toDeleteKAnswer = state.KAnswers[action.payload]
            state.KAnswers.splice(action.payload, 1)
            let hasEmpty =
                state.KAnswers.filter((item) => !item.k_answer.trim()).length >
                    0 ||
                state.KAnswers.filter((item) => item.k_answer === '{}').length >
                    0
            if (toDeleteKAnswer.ka_id) {
                return {
                    ...state,
                    KAnswers: [...state.KAnswers],
                    KAnswers_has_empty: hasEmpty,
                    KAnswers_to_delete: [
                        ...(state.KAnswers_to_delete || []),
                        toDeleteKAnswer.ka_id,
                    ],
                }
            }
            return {
                ...state,
                KAnswers_has_empty: hasEmpty,
                KAnswers: [...state.KAnswers],
            }
        }

        case 'addKSimilar': {
            const emptySimilar = makeEmptySimilar()
            return {
                ...state,
                KQuestions_has_empty: true,
                KQuestions: [...state.KQuestions, emptySimilar],
            }
        }
        case 'updateKSimilar': {
            state.KQuestions[action.payload.index].k_question =
                action.payload.value
            state.KQuestions[action.payload.index]['update'] = true
            return {
                ...state,
                KQuestions_has_empty:
                    state.KQuestions.filter((item) => !item.k_question.trim())
                        .length > 0,
                KQuestions: [...state.KQuestions],
            }
        }
        case 'deleteKSimilar': {
            const toDeleteKSimilar = state.KQuestions[action.payload]
            state.KQuestions.splice(action.payload, 1)
            const hasEmpty =
                state.KQuestions.filter((item) => !item.k_question.trim())
                    .length > 0
            if (toDeleteKSimilar.kq_id) {
                return {
                    ...state,
                    KQuestions: [...state.KQuestions],
                    KQuestions_has_empty: hasEmpty,
                    KQuestions_to_delete: [
                        ...(state.KQuestions_to_delete || []),
                        toDeleteKSimilar.kq_id,
                    ],
                }
            }
            return {
                ...state,
                KQuestions_has_empty: hasEmpty,
                KQuestions: [...state.KQuestions],
            }
        }
        default:
            throw new Error()
    }
}

export default editingKnowledgeReducer
